import { DatePicker, DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useToastContext } from "components/alert/ToastContext";
import AnexoPanel, { getFormData } from "components/anexo/AnexoPanel";
import BaseDataTableEdit from "components/dataTableableEdit/BaseDataTableEdit";
import { Label } from "components/input/Label";
import dayjs from "dayjs";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Usuario from "model/administracao/cadastro/Usuario";
import HelpdeskChamado from "model/helpdesk/HelpdeskChamado";
import HelpdeskItemCompra from "model/helpdesk/HelpdeskItemCompra";
import HelpdeskTipoChamado from "model/helpdesk/HelpdeskTipoChamado";
import HelpdeskTramite from "model/helpdesk/HelpdeskTramite";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import HelpdeskChamadoService from "service/helpdesk/HelpdeskChamadoService";
import HelpdeskTramiteService from "service/helpdesk/HelpdeskTramiteService";

const helpdeskChamadoService = new HelpdeskChamadoService();
const helpdeskTramiteService = new HelpdeskTramiteService();

type Props = {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    onConfirm: () => void;
}

export default function HelpdeskGerarChamadoClienteModal(props: Props) {

    const [photoOpen, setPhotoOpen] = useState<boolean>(false);
    const [urlOpened, setUrlOpened] = useState<string>('');
    const [clientes, setClientes] = useState<Pessoa[]>([]);
    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [usuariosCliente, setUsuariosCliente] = useState<Usuario[]>([]);
    const [tiposChamado, setTiposChamado] = useState<HelpdeskTipoChamado[]>([]);
    const [helpdeskChamado, setHelpdeskChamado] = useState<HelpdeskChamado>(new HelpdeskChamado());

    const [helpdeskTramite, setHelpdeskTramite] = useState<HelpdeskTramite>(new HelpdeskTramite());
    const [anexos, setAnexos] = useState<any[]>([])
    const [panelCollapsedAnexos, setPanelCollapsedAnexos] = useState<boolean>(false);

    const { control, setFocus, clearErrors, setError, register, formState: { errors } } = useForm();
    const { msgSucesso, msgErro, msgAlerta } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();

    const clienteRef = useRef<any>(null);

    useEffect(() => {
        helpdeskChamadoService.clientes().then((response) => {
            setClientes(response);
        }).catch((err) => {
            console.error(err);
        });
        helpdeskChamadoService.usuarios().then((response) => {
            setUsuarios(response);
        }).catch((err) => {
            console.error(err);
        });
        helpdeskChamadoService.tiposChamado().then((response) => {
            setTiposChamado(response);
        }).catch((err) => {
            console.error(err);
        });
    }, []);

    useEffect(() => {
        setHelpdeskChamado({...new HelpdeskChamado(),
            status: "AGUARDANDO_ATENDENTE",
            prioridade: "BAIXA",

        });
        setHelpdeskTramite(new HelpdeskTramite());
        setAnexos([]);
    }, [props.visible])

    function validar() {

        if (!helpdeskChamado.descricao) {
            setError("descricao", { type: "manual", message: "Descricao é obrigatória" }, { shouldFocus: true })
            return false;
        }
        if (!helpdeskChamado.tipoChamado) {
            setError("tipoChamado", { type: "manual", message: "Tipo do Chamado é obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (!helpdeskTramite.resposta) {
            setError("resposta", { type: "manual", message: "A resposta é obrigatória" }, { shouldFocus: true })
            return false;
        }
        return true;
    }

    return (
        <>
            <Dialog header="Comentários" visible={props.visible} baseZIndex={500} style={{ width: '50vw' }} onHide={() => props.setVisible(false)}>
                <div>
                    <div className="row">
                        <Label className="col col-sm-12" obrigatorio>Descrição</Label>
                        <div className="col-sm-12">
                            <InputText value={helpdeskChamado.descricao || ""} style={{ width: '50%' }}
                                {...register("descricao", {
                                    onChange: (e) => {
                                        setHelpdeskChamado({ ...helpdeskChamado, descricao: e.target.value })
                                        clearErrors("descricao")
                                    }
                                })} />
                        </div>
                    </div>
                    <div className="row">
                        <Label className="col col-sm-12" obrigatorio>Tipo do Chamado</Label>
                        <div className="col-sm-12">
                            <Controller name="tipoChamado" control={control} render={({ field }) => (
                                <Dropdown
                                    focusInputRef={field.ref}
                                    value={helpdeskChamado.tipoChamado}
                                    options={tiposChamado}
                                    optionLabel="descricao"
                                    onChange={(e) => {
                                        setHelpdeskChamado({ ...helpdeskChamado, tipoChamado: e.value })
                                        clearErrors("tipoChamado")
                                    }}
                                    style={{ width: '30%' }}
                                />
                            )} />
                        </div>
                    </div>
                    <div className="row">
                        <Label className="col col-sm-12">Nome do Solicitante</Label>
                        <div className="col-sm-12">
                            <InputText value={helpdeskChamado.nomeSolicitante || ""} style={{ width: '50%' }}
                                onChange={(e) => {
                                    setHelpdeskChamado({ ...helpdeskChamado, nomeSolicitante: e.target.value })
                                }} />
                        </div>
                    </div>
                    <div className="row">
                        <Label className="col col-sm-12" obrigatorio>Mensagem</Label>
                        <div className="col-sm-12">
                            <InputTextarea value={helpdeskTramite.resposta || ""} style={{ width: '100%' }}
                                className={errors.resposta ? "p-invalid" : ""}
                                {...register("resposta", {
                                    onChange: (e) => {
                                        setHelpdeskTramite({ ...helpdeskTramite, resposta: e.target.value })
                                        clearErrors("resposta")
                                    }
                                })} />
                        </div>
                        {errors.resposta && errors.resposta.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.resposta?.message as string}</span> : null}
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <AnexoPanel
                                novosAnexos={anexos} onChangeNovosAnexos={(e: any) => setAnexos(e)}
                                arquivos={helpdeskTramite.arquivos} onChange={(e) => {
                                    setHelpdeskTramite({ ...helpdeskTramite, arquivos: e })
                                }}
                                collapsed={panelCollapsedAnexos} onToggle={(e) => setPanelCollapsedAnexos(e.value)}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12" style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                            <Button label="Confirmar" style={{ marginRight: 30 }} onClick={() => {
                                if (validar()) {
                                    startLoading();
                                    console.log(helpdeskChamado);
                                    helpdeskChamadoService.gerarPorCliente(helpdeskChamado).then((data) => {
                                        let helpdeskTramiteLocal = {...helpdeskTramite,
                                            chamado: data
                                        }
                                        helpdeskTramiteService.gerar(getFormData("helpdeskTramite", helpdeskTramiteLocal, anexos)).then(() => {
                                            props.setVisible(false);
                                            stopLoading();
                                            props.onConfirm();
                                        }).catch(e => {
                                            stopLoading();
                                            console.error(e);
                                            if (e && e.data && e.data.message) {
                                               msgErro("Trâmite", e.data.message);
                                            } else {
                                                msgErro("Trâmite", 'Ocorreu um erro ao gerar o Trâmite, tente novamente!');
                                            }
                                        })
                                    }).catch(e => {
                                        stopLoading();
                                        console.error(e);
                                        if (e && e.data && e.data.message) {
                                            msgErro("Chamado", e.data.message);
                                        } else {
                                            msgErro("Chamado", 'Ocorreu um erro ao gerar o Chamado, tente novamente!');
                                        }
                                    });
                                } else {
                                    msgAlerta("Chamado", 'Favor, preencher todos os campos obrigatórios');
                                }
                            }} />
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    )
}